import { PROVIDER_ORIGIN_OPTIONS } from './constants'

export function buildAddProviderModalV2ProviderList(newProviders, isSaas = false) {
  const tradesmanValues = newProviders.map((item, index) => ({
    name: `tradesman.${index}`,
    value: item,
  }))

  const roundsValues = newProviders.map((item, index) => ({
    name: `rounds.${index}`,
    value: isSaas ? 1 : item.round || 0,
  }))

  return { tradesmanValues, roundsValues }
}

/**
 *
 * @param {string[]} filters - Array of filter values (e.g., ['my_providers', 'imported_from_refera'])
 * @returns
 */
export function transformFilterListIntoOptions(filters) {
  return filters.map(filter => PROVIDER_ORIGIN_OPTIONS.find(option => option.value === filter))
}
